import { useTranslation } from 'react-i18next';
import { SelectBox } from 'devextreme-react';
import TextBox from 'devextreme-react/text-box';
import { Slider, Tooltip } from 'devextreme-react/slider';
import { ThemeSettingsModel } from '../themeList';
import { fontOptions } from './fonts';

interface ThemeSettingsMenuTabProps {
  isEditable: boolean;
  menuSettings: ThemeSettingsModel;
  setMenuSettings: (settings: ThemeSettingsModel) => void;
}

export const ThemeSettingsMenuTab = ({
  isEditable,
  menuSettings,
  setMenuSettings,
}: ThemeSettingsMenuTabProps) => {
  const { t } = useTranslation();

  const updateFieldMenu = (key: keyof ThemeSettingsModel) => (value: any) => {
    setMenuSettings({
      ...menuSettings,
      [key]: value,
    });
  };

  return (
    <div className='flex w-full'>

      <div className='flex flex-col md:flex-row w-full gap-4 mt-3'>

        <div className="mt-2 rounded-md flex flex-col gap-4 border  w-full">

          <div className='flex flex-col w-full md:w-80 gap-4 min-h-96 overflow-y-auto overflow-x-hidden p-4'>

            <div className="flex flex-col justify-between w-full">
              <div className="mx-2">Site Font Family</div>
              <div className="">
                <SelectBox
                  dataSource={fontOptions}
                  displayExpr="label"
                  valueExpr="value"
                  value={menuSettings?.menu_fontfamily}
                  onValueChange={updateFieldMenu("menu_fontfamily")}
                  readOnly={!isEditable}
                  itemRender={(item) => (
                    <div style={{ fontFamily: item.value }}>
                      {item.label}
                    </div>
                  )}
                />

              </div>
            </div>

            <div className="flex flex-col w-full">
              <div className="ml-2"> Site Font Size</div>
              <div className="w-full">
                <div className="flex items-center">
                  <div className="flex-1">
                <Slider readOnly={!isEditable} min={5} max={50} value={menuSettings?.menu_fontsize} onValueChange={updateFieldMenu('menu_fontsize')}
                  className="!p-0 !m-0"
                >
                  <Tooltip enabled={true} showMode="onHover" position="bottom" />
                </Slider>
              </div>
              <span className="ml-2 relative whitespace-nowrap">
                {menuSettings?.menu_fontsize}px
              </span>
            </div>
            </div>
            </div>

          </div>

        </div>


      </div>

    </div>

  );
};

